import React, { lazy } from 'react';
interface BonusCardProps {
  title: string;
  description: string;
  imageSrc: string;
  bonusNumber: number;
}
export function BonusCard({
  title,
  description,
  imageSrc,
  bonusNumber
}: BonusCardProps) {
  return <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition-all duration-300 flex flex-col h-full" data-id="element-175">
      <div className="relative bg-gray-50 p-4 flex items-center justify-center" data-id="element-176">
        <div className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg shadow-sm z-10" data-id="element-177">
          GRATIS HOY
        </div>
        <div className="absolute top-0 left-0 bg-emerald-600 text-white text-xs font-bold px-3 py-1 rounded-br-lg shadow-sm z-10" data-id="element-178">
          BONO #{bonusNumber}
        </div>
        <img src={imageSrc} alt={`Bono ${bonusNumber}: ${title}`} className="w-3/4 h-auto object-contain transform hover:scale-105 transition-transform duration-300" loading="lazy" decoding="async" data-id="element-179" />
      </div>

      <div className="p-5 flex flex-col flex-grow text-center" data-id="element-180">
        <h3 className="text-lg font-bold text-gray-900 mb-2 leading-tight" data-id="element-181">
          {title}
        </h3>
        <p className="text-gray-600 text-sm flex-grow" data-id="element-182">{description}</p>
        <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-183">
          <span className="text-emerald-600 font-bold text-sm uppercase tracking-wide" data-id="element-184">
            Valor: <span className="line-through text-gray-400" data-id="element-185">$15 USD</span>{' '}
            <span className="text-red-500" data-id="element-186">GRATIS</span>
          </span>
        </div>
      </div>
    </div>;
}